import {Injectable} from "@angular/core";
import {ConfigurationService} from "./configuration.service";
import {AuthentService} from "./authent.service";

@Injectable()
export class UrlService {

  constructor(private configurationService:ConfigurationService, private authent:AuthentService) {
  }

  getApiUrl():string {
    return this.configurationService.getBaseUrl() + '/api';
  }

  getPublicApiUrl():string {
    return this.configurationService.getBaseUrl() + '/public';
  }

  getSiteUrl(): string {
    return this.configurationService.getFamiliesPublicUrl();
  }

  getBusinessSiteUrl(): string {
    return this.configurationService.getBusinessUrl();
  }

  getAuthentUrl():string {
    return this.configurationService.getBaseUrl() + '/oauth/token';
  }

  getPrincipalUrl():string {
    return this.getApiUrl() + '/members';
  }

  getMemberAvatarUrl(memberId:number) {
    return this.getApiUrl() + '/profiles/avatars/' + memberId + '?access_token=' + this.authent.getToken();
  }

  getBusinessesUrl() {
    return this.getApiUrl() + '/business';
  }

  getBusinessUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId;
  }

  getBusinessEventsUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/events';
  }

  getEventUrl(eventId:number) {
    return this.getApiUrl() + '/business/events/' + eventId;
  }

  getPublicEventUrl(eventId: number) {
    return this.getPublicApiUrl() + '/business/events/' + eventId;
  }

  getEventPicturesUrl(eventId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/pictures';
  }

  getEventTweetsUrl(eventId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/tweets';
  }

  getTweetDeleteUrl(eventId: number, tweetId: number) {
    return this.getEventTweetsUrl(eventId)+'/'+tweetId;
  }

  getLastTweetsUrl(eventId: number) {
    return this.getEventTweetsUrl(eventId)+'/last';
  }

  getEventPicturesUrlToModerate(eventId:number) {
    return this.getApiUrl() + '/business/moderation/' + eventId + '/pictures';
  }

  getEventTweetsUrlToModerate(eventId:number) {
    return this.getApiUrl() + '/business/moderation/' + eventId + '/tweets';
  }

  getEventModerateRefusePictures(eventId:number) {
    return this.getApiUrl() + '/business/moderation/' + eventId + '/refuse';
  }

  getEventModerateAcceptPictures(eventId:number) {
    return this.getApiUrl() + '/business/moderation/' + eventId + '/accept';
  }

  getEventModerateRefuseTweets(eventId:number) {
    return this.getApiUrl() + '/business/moderation/' + eventId + '/tweets/refuse';
  }

  getEventModerateAcceptTweets(eventId:number) {
    return this.getApiUrl() + '/business/moderation/' + eventId + '/tweets/accept';
  }

  getPublicEventPicturesUrl(eventId:number) {
    return this.getPublicApiUrl() + '/business/events/' + eventId + '/pictures';
  }

  getUploadEventPictureUrl(eventId:number) {
    return this.getApiUrl() + '/business/events/' + eventId;
  }

  getDeleteEventPictures(eventId:number, pictureIds:number[]) {
    return this.getApiUrl() + '/business/events/' + eventId + '/pictures/' + pictureIds.join();
  }

  getPictureMiniatureUrl(eventId:number, pictureId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/pictures/' + pictureId + '/miniature?access_token=' + this.authent.getToken();
  }

  getPictureUrl(eventId:number, pictureId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/pictures/' + pictureId + '?access_token=' + this.authent.getToken();
  }

  getPublicPictureMiniatureUrl(eventId:number, pictureId:number) {
    return this.getPublicApiUrl() + '/business/events/' + eventId + '/pictures/' + pictureId + '/miniature?access_token=' + this.authent.getToken();
  }

  getPublicPictureUrl(eventId:number, pictureId:number) {
    return this.getPublicApiUrl() + '/business/events/' + eventId + '/pictures/' + pictureId + '?access_token=' + this.authent.getToken();
  }

  getEventMembersUrl(eventId:number) {
    return this.getApiUrl() + '/familyAlbums/' + eventId + '/members';
  }

  getBusinessAdminsUrl(businessId:number):string {
    return this.getApiUrl() + '/business/' + businessId + '/admins';
  }

  getBusinessRemoveAdminUrl(businessId:number, adminId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/admins/' + adminId;
  }

  getEventCommentsUrl(eventId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/comments';
  }

  getDeleteCommentUrl(eventId:number, commentId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/comments/' + commentId;
  }

  getRemoveMemberUrl(eventId:number, memberId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/members/' + memberId;
  }

  getInviteMemberUrl(eventId:number) {
    return this.getApiUrl() + '/invitations/events/' + eventId;
  }

  getInviteOldMembersUrl(eventId:number) {
    return this.getApiUrl() + '/invitations/events/' + eventId + '/members';
  }

  getInviteAllOldMembersUrl(eventId:number, businessId: number) {
    return this.getApiUrl() + '/invitations/business/'+businessId+'/events/'+eventId+'/all';
  }

  getGlobalStatsUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/globalStats';
  }

  getEventGlobalStatsUrl(eventId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/globalStats';
  }

  getDatedStatsUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/stats';
  }

  getBusinessRightUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/rights';
  }

  getUpdateBusinessRightUrl() {
    return this.getApiUrl() + '/business/rights';
  }

  getUploadBusinessLogoUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/logos';
  }

  getPublicUploadBusinessLogoUrl(businessId:number) {
    return this.getPublicApiUrl() + '/business/' + businessId + '/logos';
  }

  getUploadBusinessBannerUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/banners';
  }

  getCreateBusinessTransactionUrl(businessId:number) {
    return this.getApiUrl() + '/order/' + businessId + '/start';
  }

  getDatedEventStatsUrl(eventId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/stats';
  }

  getUpdateEventCoverUrl(eventId:number, pictureId:number) {
    return this.getApiUrl() + '/business/events/' + eventId + '/cover/'+pictureId;
  }

  getPictureCommentsUrl(eventId:number, pictureId: number) {
    return this.getApiUrl() + '/business/comments/' + eventId + '/'+pictureId;
  }

  getPictureFromCommentUrl(commentId: number) {
    return this.getApiUrl() + '/business/pictures/comments/'+commentId;
  }

  getSendBusinessContactUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/contact';
  }

  getSendContactUrl() {
    return this.getApiUrl() + '/members/contact/index';
  }

  getBusinessBillsUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/bills';
  }

  getSendActivationEmailUrl(businessId:number) {
    return this.getApiUrl() + '/business/activation/' + businessId + '/send';
  }

  getActivateEmailUrl(code:string, businessId:number) {
    return this.getApiUrl() + '/activation/' + code + '/' + businessId;
  }

  getWallPicturesUrl(eventId:number) {
    return this.getApiUrl() + '/business/' + eventId + '/wall';
  }

  getLastWallPicturesUrl(eventId:number) {
    return this.getApiUrl() + '/business/' + eventId + '/wall/last';
  }

  getPublicWallPicturesUrl(eventId:number) {
    return this.getPublicApiUrl() + '/business/' + eventId + '/wall';
  }

  getPublicLastWallPicturesUrl(eventId:number) {
    return this.getPublicApiUrl() + '/business/' + eventId + '/wall/last';
  }

  getRegisterUrl() {
    return this.getApiUrl() + '/register';
  }

  getBusinessOldMemberUrl(businessId:number) {
    return this.getApiUrl() + '/business/' + businessId + '/members';
  }

  getPhotoWallUrl(eventId: number) {
    return this.getApiUrl() + '/business/' + eventId + '/photowall';
  }

  getTweetWallUrl(eventId: number) {
    return this.getApiUrl() + '/business/' + eventId + '/tweetwall';
  }

  getPublicPhotoWallUrl(eventId: number) {
    return this.getPublicApiUrl() + '/business/' + eventId + '/photowall';
  }

  getPhotoWallLogoAddUrl(eventId: number, index: number) {
    return this.getApiUrl() + '/business/' + eventId + '/photowall/'+index;
  }

  getTweetWallLogoAddUrl(eventId: number, index: number) {
    return this.getApiUrl() + '/business/' + eventId + '/tweetwall/'+index;
  }

  getTweetWallAddBackgroundUrl(eventId: number) {
    return this.getApiUrl() + '/business/' + eventId + '/tweetwall/background';
  }

  getPublicPhotowallLogoUrl(eventId:number, pictureId:number) {
    return this.getPublicApiUrl() + '/business/' + eventId + '/photowall/' + pictureId + '?access_token=' + this.authent.getToken() + '&t='+ new Date().getTime();
  }

  getPhotowallLogoUrl(eventId:number, pictureId:number) {
    return this.getApiUrl() + '/business/' + eventId + '/photowall/' + pictureId + '?access_token=' + this.authent.getToken() + '&t='+ new Date().getTime();
  }

  getTweetWallLogoUrl(eventId:number, pictureId:number) {
    return this.getApiUrl() + '/business/' + eventId + '/tweetwall/' + pictureId + '?access_token=' + this.authent.getToken() + '&t='+ new Date().getTime();
  }

  getTweetWallBackgroundUrl(eventId:number) {
    return this.getApiUrl() + '/business/' + eventId + '/tweetwall/background/stream?access_token=' + this.authent.getToken() + '&t='+ new Date().getTime();
  }

  getDownloadPictureUrl(pictureId: number) {
    return this.getApiUrl() + '/documents/pictures/' + pictureId + '/download?access_token=' + this.authent.getToken();
  }

  getEventDeepLinkUrl(eventCode: string) {
    return this.configurationService.getDeepLinkUrl()+'?event='+eventCode;
  }

  getStripeOrderUrl(sourceId: string, premiumType: string, eventId: string, businessId: number) {
    let url = this.getApiUrl() + '/stripe/business/'+businessId+'/order?sourceId='+sourceId+'&premiumType='+premiumType;

    if(eventId!=null) {
      url += '&eventId='+eventId;
    }

    return url;
  }

  getOpenStripeTransactionUrl(premiumType: string, eventId: string, businessId: number) {
    let url = this.getApiUrl() + '/stripe/business/'+businessId+'/transaction?premiumType='+premiumType;

    if(eventId!=null) {
      url += '&eventId='+eventId;
    }

    return url;
  }

  getStripePriceUrl(itemId: string, sourceId: string, businessId: number) {
    return this.getApiUrl() + '/stripe/business/'+businessId+'/price?itemId='+itemId+'&sourceId='+sourceId;
  }

  getStripeCancelUrl(businessId: number) {
    return this.getApiUrl() + '/stripe/business/'+businessId+'/cancel';
  }

  getTransactionByIntentUrl(intentId: string, businessId: number) {
    return this.getApiUrl() + '/transaction/business/'+businessId+'?intentId='+intentId;
  }

  getTweetWallBackgroundDefaultUrl() {
    return this.getBusinessSiteUrl()+'/assets/img/tweetwall-background.jpg'
  }

  getStripeBusinessSubscriptionUrl(businessId: number) {
    return this.getApiUrl() + "/stripe/business/" + businessId + "/subscription";
  }
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/url.service.ts